export default "__VITE_ASSET__a2718947__"